// ─── Detail aktivitas To-Do: label & urutan baca ────────────────────────────────
//
// Dipakai panel trainer (TodoListPanel) dan halaman Pemantauan Trainer, supaya management
// membaca "cara menjalankan" sebuah aktivitas persis seperti yang dibaca trainer saat
// memilihnya — satu kosakata, dua halaman.

// Nama kolom di berkas Excel → label yang terbaca trainer. Yang tak ada di sini tetap
// ditampilkan memakai nama aslinya: lebih baik apa adanya daripada hilang.
export const LABEL = {
  "Description": "Ringkasnya",
  "Language Focus": "Fokus bahasa",
  "Speaking Focus / Material": "Fokus speaking",
  "Material Focus / Target Output": "Target materi",
  "Target Language / Focus": "Target bahasa",
  "Target / Output": "Target",
  "Task Mechanic / Target Output": "Cara kerja tugas",
  "How to Run": "Cara menjalankan",
  "How to Deliver": "Cara menyampaikan",
  "How to Use": "Cara memakai",
  "How to Arrange": "Cara menata",
  "Trainer Steps": "Langkah trainer",
  "Trainer Steps / Steps": "Langkah trainer",
  "Main Question / Prompt": "Pertanyaan utama",
  "Follow-up Question": "Pertanyaan lanjutan",
  "Trainer Example": "Contoh dari trainer",
  "Vocabulary / Expression": "Kosakata & ungkapan",
  "Expected Student Response": "Respons yang diharapkan",
  "Quick Check": "Cek cepat",
  "Before Watching": "Sebelum menonton",
  "During Watching": "Saat menonton",
  "After Watching / Speaking Output": "Setelah menonton",
  "Duration": "Durasi",
  "Preparation Time": "Waktu persiapan",
  "Delivery Time": "Waktu penyampaian",
  "Materials": "Alat & bahan",
  "Visual Support": "Dukungan visual",
  "Recommended Class Size": "Jumlah siswa ideal",
  "Layout / Shape": "Bentuk susunan",
  "Advantages": "Kelebihan",
  "Act of Bonding": "Act of bonding",
  "Bonding Move": "Act of bonding",
  "Act of Bonding / Safety": "Act of bonding & keamanan",
  "Safety / Notes": "Perhatian",
  "Safety / Attention": "Perhatian",
  "Attention / Safety": "Perhatian",
  "Common Mistake to Avoid": "Sering keliru",
  "Suitable Level": "Cocok untuk level",
  "Suitable Level / Age": "Cocok untuk level/usia",
  "Suitable Level / Best For": "Cocok untuk",
  "Suitable For": "Cocok untuk",
  "Suitable Situation": "Cocok saat",
  "Best Used When / Source": "Paling cocok dipakai saat",
  "Interaction Pattern": "Pola interaksi",
  "Applicable Program": "Berlaku untuk program",
  "Suitable Video / Source URL": "Video contoh"
};

// Urutan baca yang masuk akal bagi orang yang sebentar lagi menjalankannya: apa ini →
// cara menjalankan → contoh → kebutuhan → hal yang perlu diwaspadai.
const URUT = [
  "Description", "Language Focus", "Speaking Focus / Material", "Material Focus / Target Output",
  "Target Language / Focus", "Target / Output", "Task Mechanic / Target Output",
  "How to Run", "How to Deliver", "How to Use", "How to Arrange",
  "Trainer Steps / Steps", "Trainer Steps",
  "Main Question / Prompt", "Follow-up Question", "Trainer Example", "Vocabulary / Expression",
  "Before Watching", "During Watching", "After Watching / Speaking Output",
  "Expected Student Response", "Quick Check",
  "Duration", "Preparation Time", "Delivery Time", "Materials", "Visual Support",
  "Recommended Class Size", "Layout / Shape", "Advantages",
  "Act of Bonding", "Bonding Move", "Act of Bonding / Safety",
  "Safety / Notes", "Safety / Attention", "Attention / Safety", "Common Mistake to Avoid"
];

export function urutkanDetail(detail) {
  const sisa = Object.keys(detail || {});
  const hasil = [];
  URUT.forEach((k) => {
    if (detail[k]) { hasil.push([k, detail[k]]); sisa.splice(sisa.indexOf(k), 1); }
  });
  sisa.forEach((k) => { if (detail[k]) hasil.push([k, detail[k]]); });
  return hasil;
}
